if ($('.js-search-extendable').length) {

	var $searchForm = $('.search[data-template="extendable"]'),
			$searchInput = $searchForm.find('.js-search-input'),
			$searchButton = $searchForm.find('.js-extendable-search-button'),
			$searchWrapperInput = $searchForm.find('.js-search-wrapper-input'),
			$searchError = $searchForm.find('.js-search-message');

	if (!$.fn.velocity) {
		console.error('Search: Для работы формы необходимо подключить VelocityJS и VelocityJS UI Pack');
	}

	function expandSearchForm() {
		var $this = $(this);
		if ($this.hasClass('is-expand')) {
			checkValLength();
		} else {
			$searchButton.addClass('is-expand');
			$.Velocity($searchWrapperInput, 'transition.slideRightIn', 200)
				.then(
					function () {
						return $searchInput.focus();
					}
				)
				.catch(console.error);
		}
	}

	function checkValLength() {
		if ($searchInput.val().length === 0) {
			$searchError.velocity('transition.slideDownIn', 200);
		} else {
			$searchForm.submit();
		}
	}

	$searchButton.on('click', function (event) {
		event.preventDefault();
		expandSearchForm.apply(this);
	});

	$searchInput
		.on('focus', function () {
			$(this).siblings('.search__label').velocity('fadeOut', 200);
			$searchError.velocity('transition.slideUpOut', 200);
		})
		.on('blur', function () {
			var $this = $(this);
			if ($this.val().length === 0){
				$this.siblings('.search__label').velocity('fadeIn', 200);
			}
		});

	$(document).on('click', function (event) {
		if (!$(event.target).closest('.js-search-extendable').length) {
			$.Velocity($searchWrapperInput, 'transition.slideRightOut', 200)
				.then(
					function () {
						$searchButton.removeClass('is-expand');
						$searchError.hide();
					}
				);
			$('.title-search-result').hide();
		}
	});
}



/** WEBPACK FOOTER **
 ** ./frontend/components/search-form/extendable/extendable.custom.js
 **/